export default __webpack_public_path__ + "img/delete.4bd169ef.svg";